import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './redux/store';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App';

const container = document.getElementById('dishop-order-module');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </ErrorBoundary>
  </Provider>
);
